import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import * as actions from './actions';
import * as brokeragesApi from './api';

export function* fetchBrokerages({ payload }) {
    const { includeDisabled } = payload;
    try {
        const brokerages = yield call(brokeragesApi.fetchAll, includeDisabled);
        yield put(actions.fetchBrokeragesSuccess(brokerages));
    } catch (e) {
        yield put(actions.fetchBrokeragesFailure(e));
    }
}

export function* syncBrokeragesWithSalesforce({ payload }) {
    const { agencyCode = null } = payload;
    try {
        const response = yield call(brokeragesApi.salesforceSynchronization, agencyCode);
        if (response) {
            yield put(actions.fetchBrokerages(undefined, true));
            yield put(actions.synchronizeWithSalesforceSuccess(response));
        } else {
            yield put(actions.synchronizeWithSalesforceFailure(
                new Error('Salesforce synchronization error')
            ));
        }
    } catch (e) {
        yield put(actions.synchronizeWithSalesforceFailure(e));
    }
}

export function* watchForFetchBrokerages() {
    yield takeEvery(actions.FETCH_BROKERAGES, fetchBrokerages);
}

export function* watchForSyncBrokeragesWithSalesforce() {
    yield takeEvery(
        actions.SYNC_WITH_SALESFORCE,
        syncBrokeragesWithSalesforce,
    )
  }

export default function* root() {
    yield all([
        fork(watchForFetchBrokerages),
        fork(watchForSyncBrokeragesWithSalesforce)
    ]);
}
